import React from 'react';
import { v1 as uuidv1 } from 'uuid';
import dotProp from 'dot-prop-immutable';

/* Utilities */
import { trans } from '~/utilities';

/* Helpers */
import colorMapping from '~/components/product-overview/helpers/colorMapping';

export default function MultiSelectList({
    filter,
    searchedChoices,
    filterIndex,
    parentFilters,
    updateFilters,
    className,
    nameMapping,
    suffix,
    showCount
}) {
    const choices = searchedChoices ? searchedChoices : filter.choices;

    const updateValue = (event, choiceKey) => {
        const { checked } = event.target;
        const foundIndex = filter.choices.findIndex((choice) => choice.key === choiceKey);
        if (foundIndex === -1) return;
        const newFilters = dotProp.set(parentFilters, `${filterIndex}.choices.${foundIndex}.active`, checked);

        updateFilters(newFilters);
    };

    const updateFilter = (choiceIndex, filters) => {
        const newFilters = dotProp.set(parentFilters, `${filterIndex}.choices.${choiceIndex}.filters`, filters);

        updateFilters(newFilters);
    };

    const sortOrder = {
        nieuw: 1,
        occasions: 2,
        demo: 3,
        company_cars: 4
    };

    return (
        <ul className={className}>
            {choices.sort((a, b) => (sortOrder[a.key] || 999) - (sortOrder[b.key] || 999)).map((choice, choiceIndex) => {
                const id = uuidv1();
                return (
                    <li key={choiceIndex} className="list-group-item">
                        <CustomCheckBox
                            id={id}
                            filter={filter}
                            choice={choice}
                            updateValue={(e) => {
                                updateValue(e, choice.key);
                            }}
                            nameMapping={nameMapping}
                            suffix={suffix}
                            showCount={showCount}
                        />

                        {/* Level Deeper */}
                        {choice.filters.length > 0 &&
                            choice.filters.map((filter, filterIndex) => {
                                if (typeof filter.choices.length !== 'undefined' && filter.choices.length > 0) {
                                    return (
                                        <MultiSelectList
                                            className={`list-group list-group-flush pl-5 ${choice.active ? '' : 'd-none'}`}
                                            parentFilters={choice.filters}
                                            filter={filter}
                                            filterIndex={filterIndex}
                                            updateFilters={(filters) => {
                                                updateFilter(choiceIndex, filters);
                                            }}
                                            key={filterIndex}
                                            showCount={showCount}
                                        />
                                    );
                                }
                            })}
                    </li>
                );
            })}
            {choices.length == 0 ? (
                <div className="mb-4">{trans('app.vehicle_overview.no_result')}</div>
            ) : null}
        </ul>
    );
}

const CustomCheckBox = ({ id, filter, choice, updateValue, nameMapping, suffix, showCount }) => {

    const onChange = (event) => {
        updateValue(event);
    };

    const capitalizeFirstLetter = (string) => {
        if (/^[a-z]-/.test(string)) {
            return string;
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const colorHex = colorMapping[capitalizeFirstLetter(choice.name)] ? colorMapping[capitalizeFirstLetter(choice.name)] : false;

    return (
        <div className={`custom-control custom-checkbox position-relative`}>
            <input
                id={id}
                name={`${filter.filterKey}[]`}
                className="custom-control-input"
                type="checkbox"
                value={choice.name}
                checked={choice.active}
                onChange={onChange}
            />

            <label className="custom-control-label d-flex align-items-center" htmlFor={id}>
                <span className="custom-control-value">
                    {nameMapping ? nameMapping[choice.name] : choice.name ? capitalizeFirstLetter(choice.name) : ''}
                    {suffix ? suffix : ''}
                    {colorHex ?
                        <div className="custom-control-color" style={{backgroundColor: colorHex}}></div>
                    : null}
                </span>
                {filter.filterKey !== 'options' && choice.count > 0 && showCount && <span className="text--14 ml-auto mr-1">{choice.count}</span>}
            </label>
        </div>
    );
};
